import React from "react";
import { Box } from "@chakra-ui/react";

export const AlienVillageBackground: React.FC = () => {
  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      overflow="hidden"
      zIndex="0"
      pointerEvents="none"
    >
      {/* Purple alien sky gradient */}
      <Box
        position="absolute"
        width="100%"
        height="100%"
        background="linear-gradient(180deg, #1a0a30 0%, #3d1a6d 25%, #6b3fa0 50%, #8b5fbf 75%, #a080d0 100%)"
      />

      {/* Alien moons */}
      <Box
        className="alien-moon-1"
        position="absolute"
        top="10%"
        right="15%"
        width="80px"
        height="80px"
        borderRadius="50%"
        background="radial-gradient(circle at 30% 30%, #e8d0ff 0%, #c8a0e8 50%, #a080c8 100%)"
        boxShadow="0 0 30px rgba(200,160,232,0.4)"
      />
      <Box
        className="alien-moon-2"
        position="absolute"
        top="18%"
        right="8%"
        width="40px"
        height="40px"
        borderRadius="50%"
        background="radial-gradient(circle at 30% 30%, #ffe8d0 0%, #e8c0a0 50%, #c8a080 100%)"
        boxShadow="0 0 20px rgba(232,192,160,0.3)"
      />

      {/* Village scene SVG */}
      <svg
        className="village-svg"
        viewBox="0 0 1440 800"
        preserveAspectRatio="none"
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      >
        <defs>
          {/* Hill gradients */}
          <linearGradient id="hillGrad1" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#4a9060" stopOpacity="1" />
            <stop offset="100%" stopColor="#2a6040" stopOpacity="1" />
          </linearGradient>
          <linearGradient id="hillGrad2" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#5aa070" stopOpacity="1" />
            <stop offset="100%" stopColor="#3a7050" stopOpacity="1" />
          </linearGradient>
          <linearGradient id="hillGrad3" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#6ab080" stopOpacity="1" />
            <stop offset="100%" stopColor="#4a8060" stopOpacity="1" />
          </linearGradient>

          {/* House dome gradients */}
          <linearGradient id="domeGrad1" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#ff9060" stopOpacity="1" />
            <stop offset="100%" stopColor="#cc6030" stopOpacity="1" />
          </linearGradient>
          <linearGradient id="domeGrad2" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#60d0ff" stopOpacity="1" />
            <stop offset="100%" stopColor="#30a0cc" stopOpacity="1" />
          </linearGradient>
          <linearGradient id="domeGrad3" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#ff60a0" stopOpacity="1" />
            <stop offset="100%" stopColor="#cc3070" stopOpacity="1" />
          </linearGradient>
          <linearGradient id="domeGrad4" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#a0ff60" stopOpacity="1" />
            <stop offset="100%" stopColor="#70cc30" stopOpacity="1" />
          </linearGradient>

          {/* Window glow */}
          <radialGradient id="windowGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#ffff80" stopOpacity="1" />
            <stop offset="100%" stopColor="#ffcc40" stopOpacity="0.8" />
          </radialGradient>
        </defs>

        {/* Back hills - round and bulbous */}
        <g className="hills-back">
          <ellipse cx="150" cy="550" rx="200" ry="120" fill="url(#hillGrad1)" />
          <ellipse cx="450" cy="520" rx="250" ry="140" fill="url(#hillGrad1)" />
          <ellipse cx="800" cy="540" rx="220" ry="130" fill="url(#hillGrad1)" />
          <ellipse cx="1100" cy="510" rx="240" ry="145" fill="url(#hillGrad1)" />
          <ellipse cx="1350" cy="550" rx="200" ry="125" fill="url(#hillGrad1)" />
        </g>

        {/* Middle hills */}
        <g className="hills-middle">
          <ellipse cx="0" cy="620" rx="180" ry="110" fill="url(#hillGrad2)" />
          <ellipse cx="300" cy="600" rx="200" ry="120" fill="url(#hillGrad2)" />
          <ellipse cx="650" cy="610" rx="230" ry="130" fill="url(#hillGrad2)" />
          <ellipse cx="1000" cy="590" rx="210" ry="125" fill="url(#hillGrad2)" />
          <ellipse cx="1300" cy="620" rx="190" ry="115" fill="url(#hillGrad2)" />
        </g>

        {/* Front hills */}
        <g className="hills-front">
          <ellipse cx="100" cy="720" rx="220" ry="130" fill="url(#hillGrad3)" />
          <ellipse cx="400" cy="700" rx="250" ry="140" fill="url(#hillGrad3)" />
          <ellipse cx="720" cy="710" rx="230" ry="135" fill="url(#hillGrad3)" />
          <ellipse cx="1050" cy="690" rx="240" ry="145" fill="url(#hillGrad3)" />
          <ellipse cx="1380" cy="720" rx="200" ry="130" fill="url(#hillGrad3)" />
        </g>

        {/* Ground */}
        <rect x="0" y="750" width="1440" height="50" fill="#4a8060" />

        {/* Alien dome houses */}
        <g className="alien-houses">
          {/* House 1 - Orange dome */}
          <ellipse cx="200" cy="680" rx="50" ry="45" fill="url(#domeGrad1)" />
          <rect x="175" y="680" width="50" height="40" fill="#cc6030" />
          <ellipse cx="200" cy="700" rx="12" ry="15" fill="url(#windowGlow)" className="house-window-1" />

          {/* House 2 - Cyan dome */}
          <ellipse cx="480" cy="650" rx="60" ry="55" fill="url(#domeGrad2)" />
          <rect x="450" y="650" width="60" height="50" fill="#30a0cc" />
          <ellipse cx="480" cy="675" rx="14" ry="18" fill="url(#windowGlow)" className="house-window-2" />

          {/* House 3 - Pink dome */}
          <ellipse cx="750" cy="670" rx="45" ry="40" fill="url(#domeGrad3)" />
          <rect x="725" y="670" width="50" height="35" fill="#cc3070" />
          <ellipse cx="750" cy="690" rx="10" ry="13" fill="url(#windowGlow)" className="house-window-3" />

          {/* House 4 - Green dome */}
          <ellipse cx="1000" cy="640" rx="55" ry="50" fill="url(#domeGrad4)" />
          <rect x="970" y="640" width="60" height="45" fill="#70cc30" />
          <ellipse cx="1000" cy="665" rx="13" ry="16" fill="url(#windowGlow)" className="house-window-4" />

          {/* House 5 - Orange dome (smaller) */}
          <ellipse cx="1220" cy="680" rx="40" ry="35" fill="url(#domeGrad1)" />
          <rect x="1200" y="680" width="40" height="30" fill="#cc6030" />
          <ellipse cx="1220" cy="695" rx="9" ry="11" fill="url(#windowGlow)" className="house-window-5" />
        </g>

      </svg>

      {/* Floating particles/spores */}
      <Box className="alien-spores" position="absolute" width="100%" height="100%" top="0" left="0">
        {[...Array(15)].map((_, i) => (
          <Box
            key={i}
            className={`spore spore-${i + 1}`}
            position="absolute"
            width={4 + (i % 3) * 2 + "px"}
            height={4 + (i % 3) * 2 + "px"}
            borderRadius="50%"
            backgroundColor={i % 3 === 0 ? "#ff80ff" : i % 3 === 1 ? "#80ffff" : "#ffff80"}
            boxShadow={`0 0 ${6 + i % 3 * 2}px ${i % 3 === 0 ? "#ff80ff" : i % 3 === 1 ? "#80ffff" : "#ffff80"}`}
            opacity="0"
          />
        ))}
      </Box>

      {/* Twinkling stars */}
      <Box className="alien-stars" position="absolute" width="100%" height="40%" top="0" left="0" />
    </Box>
  );
};

export default AlienVillageBackground;
